module.exports = __webpack_public_path__ + "img/jppdimg_mo7.63b5dbaf.png";